export default {
	custom : {
		email : {
			required : 'El campo email es obligatorio',
			email : 'Debes indicar una dirección de correo electrónico válida'
		},
		telefono : {
			required : 'El campo teléfono es obligatorio',
			length : 'El campo teléfono está mal formado'
		},
		nombre : {
			required : 'El campo nombre es obligatorio'
		},
		mensaje : {
			required : 'El campo mensaje es obligatorio'
		},
		apellidos : {
			required : 'El campo apellidos es obligatorio'
		},
		empresa : {
			required : 'El campo empresa es obligatorio'
		},
		politica : {
			required : 'Debes aceptar la política de privacidad'
		},
		direccion : {
			required : 'El campo direccion es obligatorio'
		},
		pais : {
			required : 'El campo pais es obligatorio'
		},
		carta_presentacion : {
			required : 'El campo carta de presentación es obligatorio'
		},
		doc_adjunto : {
			size : 'El tamaño maximo son 2MB',
			mimes : 'El formato debe ser PDF'
		}
	}
}


// WEBPACK FOOTER //
// ./src/validator/es.js